import posthog from "posthog-js";

let didInit = false;

export const initPostHog = () => {
  if (didInit) return;

  const apiKey = process.env.REACT_APP_COGNITO_POSTHOG_KEY;
  const apiHost = process.env.REACT_APP_COGNITO_POSTHOG_HOST;

  if (!apiKey) {
    console.warn("PostHog key is missing");
    return;
  }

  posthog.init(apiKey, {
    api_host: apiHost,
    capture_pageview: "history_change",
    autocapture: true,
    disable_session_recording: false,
    session_recording: {
      maskAllInputs: false,
      maskAllText: false,
    },
    debug: process.env.NODE_ENV !== "production",
  });

  didInit = true;

  if (typeof window !== "undefined") {
    window.posthog = posthog;
    posthog.startSessionRecording(true);
  }
};

export default posthog;
